// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__JkVUV","title":"Info_title__3IkuH","selects":"Info_selects__G8yyF","requiredAsterisk":"Info_requiredAsterisk__hlG41"};